<template>
  <DialogComponent
    ref="dialog"
    dialogId="cgu-dialog"
    type="bottomsheet"
    :hideCloseButton="false"
  >
    <div class="flex flex-col h-full">
      <h2 class="text-lg font-semibold mb-4 pr-8">
        Conditions Générales d'Utilisation
      </h2>
      <iframe
        :src="cguUrl"
        class="w-full flex-1 min-h-[60vh] rounded-lg border border-neutral-200"
        frameborder="0"
        allowfullscreen
        title="Conditions Générales d'Utilisation"
      ></iframe>
    </div>
  </DialogComponent>
</template>

<script setup>
import { ref } from 'vue';

const dialog = ref(null);
const cguUrl = 'https://www.monrapidoo.com/cgu';

function show() {
  dialog.value?.show();
}

function hide() {
  dialog.value?.hide();
}

defineExpose({ show, hide });
</script>